import { externalConstraint } from '@flatfile/plugin-constraints'
import { recordkeeperListener } from './listeners'
import {
  accountNumberValidationListener,
  accountTypevalidationListener,
  addressForCheckValidationListener,
  amountAllocableFormattingListener,
  amountFormattingListener,
  capitalGainFormattingListener,
  checkPayableInfoValidationListener,
  distributionCodeFormattingListener,
  emailAddressValidationListener,
  employeeContributionsFormattingListener,
  federalIncomeTaxAmountFormattingListener,
  federalIncomeTaxAndFederalIncomeTaxAmountValidationListener,
  federalIncomeTaxFormattingListener,
  ffcNameAndffcNumberValidationListener,
  grossDistributionAndAmountFormattingListener,
  inspiraBenefitDisbursementProcessingFeeFormattingListener,
  netAppreciationFormattingListener,
  payerStateNumberValidationListener,
  paymentInstructionsFormattingListener,
  paymentInstructionsValidationListener,
  percentageTotalDistributionFormattingListener,
  stateForCheckFormattingListener,
  stateTaxWithheldAmountFormattingListener,
  stateTaxWithheldAndStateTaxWithheldAmountValidationListener,
  stateTaxWithheldFormattingListener,
  taxableAmountFormattingListener,
  taxableAmountNotDeterminedFormattingListener,
  totalDistributionFormattingListener,
  totalEmployeeContributionsFormattingListener,
  tpaBenefitDistributionProcessingFeeFormattingListener,
  transactionTypeFormattingListener,
  wireAchwireAch2wireAch3AbaRoutingValidationListener,
  zipForCheckFormattingListener,
  zipForCheckValidationListener,
} from './bdParticipantsDataFormatting'
import {
  countryCodeStateCityZipValidationListener,
  dobFormattingListener,
  dobValidationListener,
  ssnValidationListener,
  ssnFormattingListener,
  zipCodeFormattingListener,
  planEinFormattingListener,
  planNumberFormattingListener,
  planSponsorFormattingListener,
  planNameFormattingListener,
  stateFormattingListener,
  countryCodeFormattingListener,
} from './participantsDataFormatting'

export const bdParticipantListeners = (listener, selectedPaymentMethod) => {
  /** CUSTOM DATA FORMATTING LISTENERS **/

  recordkeeperListener(listener, 'participant-record')
  planSponsorFormattingListener(listener, 'participant-record')
  planNameFormattingListener(listener, 'participant-record')
  planEinFormattingListener(listener, 'participant-record')
  planNumberFormattingListener(listener, 'participant-record')
  zipCodeFormattingListener(listener, 'participant-record')
  dobFormattingListener(listener, 'participant-record')
  ssnFormattingListener(listener, 'participant-record')
  countryCodeFormattingListener(listener, 'participant-record')
  stateFormattingListener(listener, 'participant-record')
  amountFormattingListener(listener, 'participant-record')
  tpaBenefitDistributionProcessingFeeFormattingListener(
    listener,
    'participant-record'
  )
  inspiraBenefitDisbursementProcessingFeeFormattingListener(
    listener,
    'participant-record'
  )
  transactionTypeFormattingListener(listener, 'participant-record')
  paymentInstructionsFormattingListener(listener, 'participant-record')
  grossDistributionAndAmountFormattingListener(
    listener,
    'participant-record',
    selectedPaymentMethod
  )
  capitalGainFormattingListener(listener, 'participant-record')
  netAppreciationFormattingListener(listener, 'participant-record')
  totalEmployeeContributionsFormattingListener(listener, 'participant-record')
  amountAllocableFormattingListener(listener, 'participant-record')
  stateForCheckFormattingListener(listener, 'participant-record')
  zipForCheckFormattingListener(listener, 'participant-record')
  taxableAmountFormattingListener(listener, 'participant-record')
  taxableAmountNotDeterminedFormattingListener(listener, 'participant-record')
  totalDistributionFormattingListener(listener, 'participant-record')
  employeeContributionsFormattingListener(listener, 'participant-record')
  federalIncomeTaxFormattingListener(listener, 'participant-record')
  federalIncomeTaxAmountFormattingListener(listener, 'participant-record')
  percentageTotalDistributionFormattingListener(listener, 'participant-record')
  distributionCodeFormattingListener(listener, 'participant-record')
  stateTaxWithheldFormattingListener(listener, 'participant-record')
  stateTaxWithheldAmountFormattingListener(listener, 'participant-record')

  /** CUSTOM DATA VALIDATIONS LISTENERS **/

  countryCodeStateCityZipValidationListener(listener, 'participant-record')
  dobValidationListener(listener, 'participant-record')
  ssnValidationListener(listener, 'participant-record')
  emailAddressValidationListener(listener, 'participant-record')
  paymentInstructionsValidationListener(listener, 'participant-record')
  wireAchwireAch2wireAch3AbaRoutingValidationListener(
    listener,
    'participant-record'
  )
  ffcNameAndffcNumberValidationListener(listener, 'participant-record')
  accountTypevalidationListener(listener, 'participant-record')
  checkPayableInfoValidationListener(listener, 'participant-record')
  accountNumberValidationListener(listener, 'participant-record')
  addressForCheckValidationListener(listener, 'participant-record')
  zipForCheckValidationListener(listener, 'participant-record')
  payerStateNumberValidationListener(listener, 'participant-record')
  federalIncomeTaxAndFederalIncomeTaxAmountValidationListener(
    listener,
    'participant-record'
  )
  stateTaxWithheldAndStateTaxWithheldAmountValidationListener(
    listener,
    'participant-record'
  )

  listener.use(
    externalConstraint('recordKeeper', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('tpa', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('planSponsor', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (value && new RegExp(config.invalidString.regex, 'i').test(value)) {
        record.addError(key, config.invalidString.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('planName', (value, key, { config, record }) => {
      if (value && new RegExp(config.noSlashRegex.regex).test(value)) {
        record.addError(key, config.noSlashRegex.error)
      }
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('planEin', (value, key, { config, record }) => {
      if (value && !new RegExp(config.invalidEINFormat.regex).test(value)) {
        record.addError(key, config.invalidEINFormat.error)
      }
      if (value && !new RegExp(config.invalidEIN.regex).test(value)) {
        record.addError(key, config.invalidEIN.error)
      }
    })
  )

  listener.use(
    externalConstraint('planNumber', (value, key, { config, record }) => {
      if (value && new RegExp(config.invalidCharacters.regex).test(value)) {
        record.addError(key, config.invalidCharacters.error)
      }
      if (value && !new RegExp(config.mustBeThreeDigits.regex).test(value)) {
        record.addError(key, config.mustBeThreeDigits.error)
      }
    })
  )

  listener.use(
    externalConstraint('firstName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (value && new RegExp(config.checkNamePrefix.regex, 'i').test(value)) {
        record.addError(key, config.checkNamePrefix.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('middleName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('lastName', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('addressLine1', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
      if (
        value &&
        new RegExp(config.checkNotApplicable.regex, 'i').test(value)
      ) {
        record.addError(key, config.checkNotApplicable.error)
      }
      if (
        value &&
        new RegExp(config.createEmptyValueValidator.regex).test(value)
      ) {
        record.addError(key, config.createEmptyValueValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('addressLine2', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('city', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('phone', (value, key, { config, record }) => {
      if (value && !new RegExp(config.phoneNumber.regex).test(value)) {
        record.addError(key, config.phoneNumber.error)
      }
    })
  )

  listener.use(
    externalConstraint('ssn', (value, key, { config, record }) => {
      if (value && new RegExp(config.ssnValidityCheck.regex).test(value)) {
        record.addError(key, config.ssnValidityCheck.error)
      }
    })
  )

  listener.use(
    externalConstraint('emailAddress', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint('transactionType', (value, key, { config, record }) => {
      if (value && !new RegExp(config.transactionType.regex, 'i').test(value)) {
        record.addError(key, config.transactionType.error)
      }
    })
  )

  listener.use(
    externalConstraint('amount', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )

  listener.use(
    externalConstraint(
      'tpaBenefitDistributionProcessingFee',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      'paymentInstructions',
      (value, key, { config, record }) => {
        if (
          value &&
          !new RegExp(config.paymentInstructions.regex, 'i').test(value)
        ) {
          record.addError(key, config.paymentInstructions.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      'inspiraBenefitDisbursementProcessingFee',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )

  listener.use(
    externalConstraint(
      'grossDistributionAmount',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint('wireAch', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint('abaRouting', (value, key, { config, record }) => {
      if (value && !new RegExp(config.abaRouting.regex, 'i').test(value)) {
        record.addError(key, config.abaRouting.error)
      }
    })
  )
  listener.use(
    externalConstraint('wireAch2', (value, key, { config, record }) => {
      if (value && !new RegExp(config.wireAch2.regex, 'i').test(value)) {
        record.addError(key, config.wireAch2.error)
      }
    })
  )
  listener.use(
    externalConstraint('wireAch3', (value, key, { config, record }) => {
      if (value && !new RegExp(config.wireAch3.regex, 'i').test(value)) {
        record.addError(key, config.wireAch3.error)
      }
    })
  )
  listener.use(
    externalConstraint('ffcName', (value, key, { config, record }) => {
      if (value && !new RegExp(config.ffcName.regex, 'i').test(value)) {
        record.addError(key, config.ffcName.error)
      }
    })
  )
  listener.use(
    externalConstraint('ffcNumber', (value, key, { config, record }) => {
      if (value && !new RegExp(config.ffcNumber.regex, 'i').test(value)) {
        record.addError(key, config.ffcNumber.error)
      }
    })
  )
  listener.use(
    externalConstraint('accountType', (value, key, { config, record }) => {
      if (value && !new RegExp(config.accountType.regex, 'i').test(value)) {
        record.addError(key, config.accountType.error)
      }
    })
  )
  listener.use(
    externalConstraint('checkPayableInfo', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint('accountNumber', (value, key, { config, record }) => {
      if (value && !new RegExp(config.accountNumber.regex, 'i').test(value)) {
        record.addError(key, config.accountNumber.error)
      }
    })
  )
  listener.use(
    externalConstraint('addressForCheck', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint('cityForCheck', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint('stateForCheck', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint('zipForCheck', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint(
      'grossDistribution',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint('taxableAmount', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint(
      'taxableAmountNotDetermined',
      (value, key, { config, record }) => {
        if (
          value &&
          !new RegExp(config.taxableAmountNotDetermined.regex, 'i').test(value)
        ) {
          record.addError(key, config.taxableAmountNotDetermined.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint(
      'totalDistribution',
      (value, key, { config, record }) => {
        if (
          value &&
          !new RegExp(config.totalDistribution.regex, 'i').test(value)
        ) {
          record.addError(key, config.totalDistribution.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint('capitalGain', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint('federalIncomeTax', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint(
      'federalIncomeTaxAmount',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint(
      'employeeContributions',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint('netAppreciation', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint('distributionCode', (value, key, { config, record }) => {
      if (value && !new RegExp(config.invalidFormat.regex).test(value)) {
        record.addError(key, config.invalidFormat.error)
      }
      if (value && !new RegExp(config.lengthCheck.regex).test(value)) {
        record.addError(key, config.lengthCheck.error)
      }
    })
  )
  listener.use(
    externalConstraint(
      'percentageTotalDistribution',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint(
      'totalEmployeeContributions',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint('amountAllocable', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint('firstYearContrib', (value, key, { config, record }) => {
      if (
        value &&
        !new RegExp(config.firstYearContrib.regex, 'i').test(value)
      ) {
        record.addError(key, config.firstYearContrib.error)
      }
    })
  )
  listener.use(
    externalConstraint('stateTaxWithheld', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
  listener.use(
    externalConstraint(
      'stateTaxWithheldAmount',
      (value, key, { config, record }) => {
        if (
          value &&
          new RegExp(config.createMaxCharValidator.regex).test(value)
        ) {
          record.addError(key, config.createMaxCharValidator.error)
        }
      }
    )
  )
  listener.use(
    externalConstraint('payerStateNumber', (value, key, { config, record }) => {
      if (
        value &&
        new RegExp(config.createMaxCharValidator.regex).test(value)
      ) {
        record.addError(key, config.createMaxCharValidator.error)
      }
    })
  )
}
